import React, { useState } from 'react';

interface InfoTooltipProps {
  // Inhalt der Sprechblase (Text oder beliebiger Knoten, z.B. mit <strong>)
  text: React.ReactNode;
  // Beschriftung fuer Screenreader
  label?: string;
}

/**
 * Kleines i-Symbol, das bei Hover oder Tastaturfokus einen erklaerenden Text in
 * einer Sprechblase zeigt. Ersetzt die frueheren, dauerhaft sichtbaren blauen
 * Info-Boxen und uebernimmt deren Farbgebung. Rein mit React-State und
 * Inline-Styles, kein Browser-Storage.
 */
export const InfoTooltip: React.FC<InfoTooltipProps> = ({ text, label = 'Weitere Informationen' }) => {
  const [visible, setVisible] = useState(false);

  return (
    <span style={{ position: 'relative', display: 'inline-flex', verticalAlign: 'middle' }}>
      <button
        type="button"
        aria-label={label}
        onMouseEnter={() => setVisible(true)}
        onMouseLeave={() => setVisible(false)}
        onFocus={() => setVisible(true)}
        onBlur={() => setVisible(false)}
        style={{
          width: '18px',
          height: '18px',
          borderRadius: '50%',
          border: '1px solid #BFDBFE',
          backgroundColor: '#EFF6FF',
          color: '#1D4ED8',
          fontSize: '12px',
          fontWeight: 700,
          fontStyle: 'italic',
          lineHeight: '1',
          cursor: 'help',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: 0
        }}
      >
        i
      </button>
      {visible && (
        <span
          role="tooltip"
          style={{
            position: 'absolute',
            top: '24px',
            left: 0,
            zIndex: 50,
            width: '360px',
            maxWidth: '80vw',
            padding: '12px 16px',
            backgroundColor: '#EFF6FF',
            border: '1px solid #BFDBFE',
            borderRadius: '6px',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
            fontSize: '13px',
            color: '#1D4ED8',
            lineHeight: '1.5',
            fontWeight: 400,
            textAlign: 'left',
            whiteSpace: 'normal'
          }}
        >
          {text}
        </span>
      )}
    </span>
  );
};
